'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdViewWeek = function MdViewWeek(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.6 8.4c1 0 1.8 0.7 1.8 1.6v20c0 0.9-0.8 1.6-1.8 1.6h-5c-0.9 0-1.6-0.7-1.6-1.6v-20c0-0.9 0.7-1.6 1.6-1.6h5z m11.8 0c0.9 0 1.6 0.7 1.6 1.6v20c0 0.9-0.7 1.6-1.6 1.6h-5c-1 0-1.8-0.7-1.8-1.6v-20c0-0.9 0.8-1.6 1.8-1.6h5z m-23.4 0c0.9 0 1.6 0.7 1.6 1.6v20c0 0.9-0.7 1.6-1.6 1.6h-5c-0.9 0-1.6-0.7-1.6-1.6v-20c0-0.9 0.7-1.6 1.6-1.6h5z' })
        )
    );
};

exports.default = MdViewWeek;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/view-week.js
// module id = 2112
// module chunks = 168707334958949